export const financialStatistics = {
    'zh-CN': {
        frozenCommissionTip: '此冻结佣金为已完成分销订单中分销员的"未入账"和"未提现到账"分销佣金。',
        waitingPayment: '等待打款',
        paymentSuccess: '打款成功',
        rejected: '已驳回',
        approvedWaitingPayment: '审核通过待打款',
        balanceText: '/余额',
        yuan: '港元',
        lastSevenDays: '近七天',
        lastThirtyDays: '近三十天',
        lastNinetyDays: '近九十天',
        cumulativeProductIncome: '累计商品收入',
        cumulativeProductIncomeTip: '累计商品金额-累计优惠金额-累计分销佣金金额',
        orderNumber: '订单编号',
        productName: '商品名称',
        cumulativeProductAmount: '累计商品金额',
        productAmount: '商品金额(原价)',
        cumulativeDiscountAmount: '累计优惠金额',
        discountAmount: '优惠金额',
        actualPaymentAmount: '实付金额',
        cumulativeCommissionAmount: '累计分销佣金金额',
        orderType: '订单类型',
        distributionCommission: '分销佣金',
        balanceWithdrawal: '余额提现',
        receivingAccount: '收款账户',
        withdrawalAccountDefault: '提现账户默认为企业BOSS账户，不可更改',
        withdrawalAmount: '提现金额',
        withdrawalAmountPlaceholder: '请输入提现金额',
        withdrawAll: '全部提现',
        minimumWithdrawalAmount: '最低提现金额',
        currentWithdrawableAmount: '当前可提现金额',
        cancel: '取消',
        confirm: '确认',
        nonBossPermissionError: '此行为非boss权限不可操作',
        withdrawalAmountTooLow: '提现金额不得小于最低提现金额',
        withdrawalSuccess: '提现成功'
      },
      'zh-TW': {
        frozenCommissionTip: '此凍結佣金為已完成分銷訂單中分銷員的"未入賬"和"未提現到賬"分銷佣金。',
        waitingPayment: '等待打款',
        paymentSuccess: '打款成功',
        rejected: '已駁回',
        approvedWaitingPayment: '審核通過待打款',
        balanceText: '/餘額',
        yuan: '港元',
        lastSevenDays: '近七天',
        lastThirtyDays: '近三十天',
        lastNinetyDays: '近九十天',
        cumulativeProductIncome: '累計商品收入',
        cumulativeProductIncomeTip: '累計商品金額-累計優惠金額-累計分銷佣金金額',
        orderNumber: '訂單編號',
        productName: '商品名稱',
        cumulativeProductAmount: '累計商品金額',
        productAmount: '商品金額(原價)',
        cumulativeDiscountAmount: '累計優惠金額',
        discountAmount: '優惠金額',
        actualPaymentAmount: '實付金額',
        cumulativeCommissionAmount: '累計分銷佣金金額',
        orderType: '訂單類型',
        distributionCommission: '分銷佣金',
        balanceWithdrawal: '餘額提現',
        receivingAccount: '收款賬戶',
        withdrawalAccountDefault: '提現賬戶默認為企業BOSS賬戶，不可更改',
        withdrawalAmount: '提現金額',
        withdrawalAmountPlaceholder: '請輸入提現金額',
        withdrawAll: '全部提現',
        minimumWithdrawalAmount: '最低提現金額',
        currentWithdrawableAmount: '當前可提現金額',
        cancel: '取消',
        confirm: '確認',
        nonBossPermissionError: '此行為非boss權限不可操作',
        withdrawalAmountTooLow: '提現金額不得小於最低提現金額',
        withdrawalSuccess: '提現成功'
      },
      'en': {
        frozenCommissionTip: 'This frozen commission is the "unaccounted" and "unwithdrawn" distribution commission of distributors in completed distribution orders.',
        waitingPayment: 'Waiting Payment',
        paymentSuccess: 'Payment Success',
        rejected: 'Rejected',
        approvedWaitingPayment: 'Approved Waiting Payment',
        balanceText: '/Balance',
        yuan: 'HK$',
        lastSevenDays: 'Last 7 Days',
        lastThirtyDays: 'Last 30 Days',
        lastNinetyDays: 'Last 90 Days',
        cumulativeProductIncome: 'Cumulative Product Income',
        cumulativeProductIncomeTip: 'Cumulative Product Amount - Cumulative Discount Amount - Cumulative Commission Amount',
        orderNumber: 'Order Number',
        productName: 'Product Name',
        cumulativeProductAmount: 'Cumulative Product Amount',
        productAmount: 'Product Amount (Original Price)',
        cumulativeDiscountAmount: 'Cumulative Discount Amount',
        discountAmount: 'Discount Amount',
        actualPaymentAmount: 'Actual Payment Amount',
        cumulativeCommissionAmount: 'Cumulative Commission Amount',
        orderType: 'Order Type',
        distributionCommission: 'Distribution Commission',
        balanceWithdrawal: 'Balance Withdrawal',
        receivingAccount: 'Receiving Account',
        withdrawalAccountDefault: 'Withdrawal account defaults to enterprise BOSS account and cannot be changed',
        withdrawalAmount: 'Withdrawal Amount',
        withdrawalAmountPlaceholder: 'Please enter withdrawal amount',
        withdrawAll: 'Withdraw All',
        minimumWithdrawalAmount: 'Minimum Withdrawal Amount',
        currentWithdrawableAmount: 'Current Withdrawable Amount',
        cancel: 'Cancel',
        confirm: 'Confirm',
        nonBossPermissionError: 'This action requires BOSS permissions',
        withdrawalAmountTooLow: 'Withdrawal amount cannot be less than minimum withdrawal amount',
        withdrawalSuccess: 'Withdrawal successful'
      }
}